import { Dialog, DialogPanel } from '@headlessui/react';
import Card from '@app/components/card/card';
import CardHeader from '@app/components/card/card-header';
import CardContent from '@app/components/card/card-content';
import CardFooter from '@app/components/card/card-footer';
import PrimaryButton from '@app/components/primary-button';
import { useTranslate } from '@tolgee/react';

export default function MinimumPriceDialog(props: { isOpen: boolean; closeDialog: () => void }) {
  const { isOpen, closeDialog } = props;
  const { t } = useTranslate();

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} as="div" className="minimum-price-dialog relative z-50" onClose={closeDialog}>
      {/* Backdrop */}
      <div className="minimum-price-dialog__backdrop fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Full-screen container to center the panel */}
      <div className="minimum-price-dialog__overlay fixed inset-0 z-50 overflow-y-auto">
        <div className="minimum-price-dialog__container flex min-h-full items-center justify-center p-4">
          <DialogPanel className="minimum-price-dialog__panel">
            <Card className="minimum-price-dialog__card">
              <CardHeader
                className="minimum-price-dialog__header"
                title={t('storefront.online-order.minimum-price-dialog.header', 'Minimum Order Value Required')}
              />
              <CardContent className="minimum-price-dialog__content">
                <p className="minimum-price-dialog__message text-gray-600">
                  {t(
                    'storefront.online-order.minimum-price-dialog.content',
                    'Your cart total does not meet the minimum order value'
                  )}
                </p>
              </CardContent>
              <CardFooter className="minimum-price-dialog__footer">
                <div className="minimum-price-dialog__actions flex w-full justify-center">
                  <PrimaryButton
                    className="minimum-price-dialog__button w-full bg-indigo-600 px-6 hover:bg-indigo-400 sm:w-auto"
                    onClick={closeDialog}
                  >
                    {t('storefront.online-order.minimum-price-dialog.button.close', 'Close')}
                  </PrimaryButton>
                </div>
              </CardFooter>
            </Card>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}